export default __webpack_public_path__ + "static/media/templateTime_ic.1dfb9802.svg";